import { MoreOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { MathEnabledTextComponent, TextLinkButton, styleVariables, useMaxLengthText } from '@lib/common';
import { Col, Popover, Row, Space } from 'antd';
import styled from 'styled-components';
import { warningPopover } from './section-summary.component';
import { getSize } from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledQuestionTitle = styled(Row).withConfig({
  displayName: "question-summarycomponent__StyledQuestionTitle",
  componentId: "sc-184eu4o-0"
})(["color:", ";background-color:", ";border-left:", ";display:flex;justify-content:space-between;align-items:center;cursor:pointer;z-index:1;padding:", ";p{margin-bottom:0px;}&:hover{color:", ";background-color:", ";}"], function (_ref) {
  var $active = _ref.$active;
  return $active ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray11;
}, function (_ref2) {
  var $active = _ref2.$active;
  return $active ? styleVariables.colors.gray6 : 'transparent';
}, function (_ref3) {
  var $active = _ref3.$active;
  return $active ? "3px solid ".concat(styleVariables.colors.colorPrimaryBase) : '0px';
}, getSize('padding8'), styleVariables.colors.colorPrimaryBase, styleVariables.colors.gray4);
var StyledQuestionLabel = styled(Col).withConfig({
  displayName: "question-summarycomponent__StyledQuestionLabel",
  componentId: "sc-184eu4o-1"
})(["font-weight:600;font-size:14px;padding-left:8px;"]);
var StyledTextLinkButton = styled(TextLinkButton).withConfig({
  displayName: "question-summarycomponent__StyledTextLinkButton",
  componentId: "sc-184eu4o-2"
})(["color:", ";font-weight:500;line-height:24px;"], styleVariables.colors.blue4);
var StyledMoreButtonComponent = styled(TextLinkButton).withConfig({
  displayName: "question-summarycomponent__StyledMoreButtonComponent",
  componentId: "sc-184eu4o-3"
})(["min-width:100% !important;width:100% !important;"]);
var QuestionDescriptionValue = styled(MathEnabledTextComponent).withConfig({
  displayName: "question-summarycomponent__QuestionDescriptionValue",
  componentId: "sc-184eu4o-4"
})(["margin-left:4px;"]);
export var QuestionSummaryComponent = function QuestionSummaryComponent(_ref4) {
  var questions = _ref4.questions,
      onCreateQuestion = _ref4.onCreateQuestion,
      hasUnsavedQuestionOrSectionChanges = _ref4.hasUnsavedQuestionOrSectionChanges,
      onSelectQuestion = _ref4.onSelectQuestion,
      labelTranslation = _ref4.labelTranslation,
      selectedFormItemId = _ref4.selectedFormItemId;
  var maxLength = useMaxLengthText(20);

  var moreContent = function moreContent(question) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick() {
            return onCreateQuestion({
              currentQuestionId: question.id.toString(),
              aboveQuestionId: question.previousQuestionId
            });
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: labelTranslation.addQuestionAbove
        }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick() {
            return onCreateQuestion({
              currentQuestionId: question.id.toString(),
              belowQuestionId: question.id.toString()
            });
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: labelTranslation.addQuestionBelow
        })]
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: questions.map(function (question) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: !hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsxs(StyledQuestionTitle, {
          $active: selectedFormItemId === question.id.toString(),
          onClick: function onClick() {
            return onSelectQuestion(question);
          },
          children: [/*#__PURE__*/_jsxs(StyledQuestionLabel, {
            span: 4,
            children: [question.titleIndex, "."]
          }), /*#__PURE__*/_jsx(Col, {
            span: 16,
            children: /*#__PURE__*/_jsx(QuestionDescriptionValue, {
              value: question.getTruncatedText(maxLength)
            })
          }), /*#__PURE__*/_jsx(Col, {
            span: 2,
            children: question.score
          })]
        }, question.id.toString()) : /*#__PURE__*/_jsx(Popover, {
          title: "",
          content: warningPopover(labelTranslation.questionChangingWarning),
          trigger: 'hover',
          children: /*#__PURE__*/_jsxs(StyledQuestionTitle, {
            $active: selectedFormItemId === question.id.toString(),
            children: [/*#__PURE__*/_jsxs(StyledQuestionLabel, {
              span: 4,
              children: [question.titleIndex, "."]
            }), /*#__PURE__*/_jsx(Col, {
              span: 16,
              children: /*#__PURE__*/_jsx(QuestionDescriptionValue, {
                value: question.getTruncatedText(maxLength)
              })
            }), /*#__PURE__*/_jsx(Col, {
              span: 2,
              children: question.score
            }), /*#__PURE__*/_jsx(Col, {
              span: 2,
              children: /*#__PURE__*/_jsx(StyledMoreButtonComponent, {
                size: "large",
                icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
                type: "text",
                shape: "circle"
              })
            })]
          }, question.id.toString())
        })
      });
    })
  });
};